<form (ngSubmit)="onDownload()" [formGroup]="cropForm" class="flex flex-col justify-center items-center p-4">
  <mat-form-field>
    <mat-label>{{ 'catalog.image_preview.format' | transloco }}</mat-label>

    <mat-select [compareWith]="compareFormats" formControlName="format">
      @for (format of formats; track format) {
        <mat-option [value]="format">
          @if (format.icon) {
            <span [ngClass]="[format.icon]" class="mr-2"></span>
          }
          {{ format.label }}
        </mat-option>
      }
    </mat-select>

    @if (cropForm.value.format) {
      <span [ngClass]="[cropForm.value.format.icon, 'mr-2']" matPrefix></span>
    }
  </mat-form-field>

  @if (formatSizes$ | async; as formatSizes) {
    @if (formatSizes.length > 0) {
      <div class="mt-2">
        <mat-form-field>
          <mat-label>{{ 'catalog.image_preview.format_size' | transloco }}</mat-label>
          <mat-select [compareWith]="compareFormatSizes" formControlName="formatSize">
            @for (formatSize of formatSizes; track formatSize) {
              <mat-option [value]="formatSize">
                {{ formatSize.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  }

  @if (watermarkSources$ | async; as watermarkSources) {
    @if (watermarkSources.length > 0) {
      <div class="mt-2">
        <mat-form-field>
          <mat-label>{{ 'catalog.image_preview.watermark_source' | transloco }}</mat-label>
          <mat-select [compareWith]="compareWatermarkSources" formControlName="watermarkSource">
            @for (source of watermarkSources; track source) {
              <mat-option [value]="source">
                {{ source.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  }

  @if (watermarkPositions$ | async; as watermarkPositions) {
    @if (watermarkPositions.length > 0 && cropForm.value.watermarkSource && cropForm.value.watermarkSource.id !== 'none') {
      <div
        class="mt-2"
      >
        <mat-form-field>
          <mat-label>{{ 'catalog.image_preview.watermark_position' | transloco }}</mat-label>
          <mat-select [compareWith]="compareWatermarkPositions" formControlName="watermarkPosition">
            @for (position of watermarkPositions; track position) {
              <mat-option [value]="position">
                @if (position.icon) {
                  <span [ngClass]="[position.icon]" class="mr-2"></span>
                }
                {{ position.label }}
              </mat-option>
            }
          </mat-select>
          @if (cropForm.value.watermarkPosition) {
            <span
              [ngClass]="[cropForm.value.watermarkPosition.icon || '', 'mr-2']"
              matPrefix
            ></span>
          }
        </mat-form-field>
      </div>
    }
  }

  <button
    [disabled]="!cropForm.valid"
    [loading]="loading$ | async"
    class="mt-2 secondary-button secondary-progress-spinner"
    mat-raised-button
  >
    <mat-icon>cloud_download</mat-icon>
    {{ 'catalog.image_preview.download' | transloco }}
  </button>
</form>
